export const APAC_FLIGHT_NAME = "apac-flights";
export enum ApacFlightsComponent {
  FlightItineraryDetailSummary = "FlightItineraryDetailSummary",
  FlightItineraryDetailAddOns = "FlightItineraryDetailAddOns",
  FlightItineraryDetailSliceSummary = "FlightItineraryDetailSliceSummary",
  FlightItineraryDetailTravelers = "FlightItineraryDetailTravelers",
  FlightItineraryDetailBookingConfirmation = "FlightItineraryDetailBookingConfirmation",
  FlightItineraryDetailPayment = "FlightItineraryDetailPayment",
  BookingConfirmationCard = "BookingConfirmationCard",
  CardPayment = "CardPayment",
  NonCardPayment = "NonCardPayment",
  PaymentPerTraveler = "PaymentPerTraveler",
  TripTotal = "TripTotal",
  ConnectedAirCfarExercise = "ConnectedAirCfarExercise",
  FlightItinerarySelfServeLinks = "FlightItinerarySelfServeLinks",
  CustomerSupportModal = "CustomerSupportModal",
  CustomerSupportModalContent = "CustomerSupportModalContent",
  CancelFlightModal = "CancelFlightModal",
  ExchangeFlightModal = "ExchangeFlightModal",
  ResendEmailModal = "ResendEmailModal",
  ApacFlightsCfarExercisePageRoute = "ApacFlightsCfarExercisePageRoute",
}
